<div class="profile-badges" [class.--is-desktop]="isDesktop">
  <div class="__badge __reactions">
    <mip-profile-reactions [profile]="profile" [isMobile]="isMobile" [isDesktop]="isDesktop" (toggleReactions)="toggleReactions()"></mip-profile-reactions>
  </div>

  <button [class.--hidden]="isInteractionsActionsOpened" mat-button class="__badge --block">
    <div class="info">
      <strong>{{ profile.userStats.posts | millify : 2 : 10000 }}</strong>
      <small mipTranslate="profile.badges.posts">Posts</small>
    </div>
  </button>

  <!-- FOLLOWERS COUNT -->
  <a [class.--hidden]="isInteractionsActionsOpened" mat-button class="__badge" [routerLink]="profile.userStats.followers > 0 ? 'info/followers' : '/@' + profile.username">
    <div class="info">
      <strong>{{ profile.userStats.followers | millify : 2 : 10000 }}</strong>
      <small mipTranslate="profile.badges.followers">Followers</small>
    </div>
  </a>

  <!-- FOLLOWING COUNT -->
  <a [class.--hidden]="isInteractionsActionsOpened" mat-button class="__badge" [routerLink]="profile.userStats.following > 0 ? 'info/following' : '/@' + profile.username">
    <div class="info">
      <strong>{{ profile.userStats.following | millify : 2 : 10000 }}</strong>
      <small mipTranslate="profile.badges.following">Following</small>
    </div>
  </a>
</div>
